import { parseRequestError } from '@/app/common/utilities'
import { useToast } from '@/shad/ui/toast/use-toast'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { paymentApprovalApi } from '../api'
import { paymentApprovalKeys } from '../keys'
import { ApprovalRulePayload } from '../schema'

interface EditRuleArgs {
  ruleId: number
  rule: ApprovalRulePayload
}

type Props = {
  onSuccess: () => void
  onError?: () => void
}

export default function useEditRule({ onSuccess, onError }: Props) {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: async ({ ruleId, rule }: EditRuleArgs) => {
      return await paymentApprovalApi.updateRule(ruleId, rule)
    },
    onSuccess: () => {
      toast({
        title: 'Rule updated',
        description: 'Rule updated successfully',
      })

      queryClient.invalidateQueries({
        // We only  want the two first keys here because we want to invalidate all the rules
        // This way we don't have to pass all the params from the rules query to invalidate the query
        queryKey: paymentApprovalKeys.allRules().slice(0, 2),
      })

      onSuccess()
    },

    onError: (error) => {
      const parsedError = parseRequestError(error)

      toast({
        title: 'Error updating rule',
        description: parsedError.message,
        variant: 'destructive',
      })
      onError?.()
    },
  })
}
